import React, { useState } from "react";
import { Share, Copy, Check } from "@phosphor-icons/react";
import { API } from "../context/AuthContext";
import { toast } from "sonner";

/**
 * Native-share (mobile) + copy-link (desktop) button. The share URL points
 * at /u/:userId which the backend can serve with an OG image for previews.
 */
export default function ShareProfileButton({ userId, name, sun, moon, rising }) {
    const [copied, setCopied] = useState(false);
    // Use the backend /api/share/user URL so social crawlers get proper OG meta tags.
    // Real browsers auto-redirect to /u/:userId via meta-refresh.
    const shareUrl = `${API}/share/user/${userId}`;
    const ogUrl = `${API}/og/user/${userId}.png`;

    const doShare = async () => {
        const shareData = {
            title: `${name} on SoulStar Dating`,
            text: `${name} \u2014 ${sun} Sun, ${moon} Moon, ${rising} Rising. See our cosmic compatibility on SoulStar.`,
            url: shareUrl,
        };
        if (typeof navigator !== "undefined" && navigator.share) {
            try {
                await navigator.share(shareData);
                return;
            } catch (err) {
                if (err?.name === "AbortError") return;
            }
        }
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            toast.success("Profile link copied");
            setTimeout(() => setCopied(false), 2000);
        } catch {
            toast.error("Could not copy link");
        }
    };

    return (
        <div className="inline-flex items-center gap-2">
            <button
                onClick={doShare}
                className="btn-gold inline-flex items-center gap-2"
                data-testid="share-profile-btn"
                title="Share profile"
            >
                {copied ? <Check size={16} weight="bold" /> : <Share size={16} weight="duotone" />}
                {copied ? "Copied" : "Share"}
            </button>
            <a
                href={ogUrl}
                target="_blank"
                rel="noreferrer"
                className="hidden sm:inline-flex text-xs label-tracking text-muted hover:text-gold transition-colors items-center gap-1"
                data-testid="preview-og-card"
                title="Preview share card"
            >
                <Copy size={12} /> Preview card
            </a>
        </div>
    );
}
